import React, { PropTypes as pt } from 'react';

const IBox = ({ children, title, tools }) => (
    <div className="ibox">
        <div className="ibox-title">
            <h5>{title}</h5>
            {tools && <div className="ibox-tools">{tools}</div>}
        </div>
        <div className="ibox-content">{children}</div>
    </div>
);

IBox.propTypes = {
    title: pt.string,
    children: pt.node,
    tools: pt.node,
};

export default IBox;



// WEBPACK FOOTER //
// ./src/incab/common/components/IBox.jsx